<template v-slot:append>
  <v-dialog
    v-model="showDialog"
    max-width="90%"
    persistent
    no-click-animation>
    <v-card min-height="60%" min-width="90%">
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>契約に紐づく受注一覧</v-toolbar-title>
        <v-spacer></v-spacer>
        <dd-icon-button
          @click="onCloseClick"
          icon="mdi-close"/>
      </v-toolbar>

      <v-card-text>
        <v-container>
          <v-row no-gutters align-content="center">
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col :cols="6" class="px-1">
                  <dd-text-box
                    label="受注契約番号"
                    :length="10"
                    v-model="juchuKeiyaku.juchuKeiyakuNo"
                    ref="juchuKeiyakuNo"
                    :valueType="Ctrls.InputTypes.Number"
                    :readonly="true"
                    dense/>
                </v-col>
                <v-col :cols="6" class="px-1">
                  <dd-text-box
                    label="契約名"
                    v-model="juchuKeiyaku.keiyakuNm"
                    ref="keiyakuNm"
                    :valueType="Ctrls.InputTypes.Free"
                    :readonly="true"
                    dense/>
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col class="px-1">
                  <dd-code-text-box
                    label="請求先コード/名称"
                    v-model="juchuKeiyaku.seikyusakiCd"
                    ref="seikyusakiCd"
                    :valueType="Ctrls.InputTypes.Free"
                    titleText="請求先検索"
                    item-value="torihikisakiCd"
                    item-text="torihikisakiNm"
                    :headerList="headersSeikyusakiList"
                    :itemList="filteredSeikyusakiList"
                    :readonly="true"
                    dense/>
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col :cols="4" class="px-1">
                  <dd-date-box
                    label="契約開始日"
                    v-model="juchuKeiyaku.keiyakuStartYmdDisp"
                    ref="keiyakuStartYmd"
                    :readonly="true"
                    dense/>
                </v-col>
                <v-col :cols="4" class="px-1">
                  <dd-date-box
                    label="契約満了日"
                    v-model="juchuKeiyaku.keiyakuEndYmdDisp"
                    ref="keiyakuEndYmd"
                    :readonly="true"
                    dense/>
                </v-col>
                <v-col :cols="4" class="px-1">
                  <dd-text-box
                    label="契約基本金額"
                    v-model="juchuKeiyaku.keiyakuKihonKingaku"
                    ref="keiyakuKihonKingaku"
                    :valueType="Ctrls.InputTypes.Free"
                    :readonly="true"
                    dense/>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="spx" />
          <v-row no-gutters align-content="center">
            <v-col :cols="2"></v-col>
            <v-col :cols="10">
              <v-row no-gutters align-content="center">
                <v-col class="px-1">
                  <dd-text-box
                    label="請求先備考"
                    v-model="juchuKeiyaku.juchuKeiyakuBiko"
                    ref="juchuKeiyakuBiko"
                    :valueType="Ctrls.InputTypes.Free"
                    :readonly="true"
                    dense/>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="spx" />

          <v-row no-gutters>
            <v-col :cols="12">
              <dd-data-table
                item-key="id"
                height="50vh"
                :headers="headers"
                :items="filteredJuchuRows"
                :search="searchText"
                :custom-filter="filtering"
                :page.sync ="page"/>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <dd-default-button
          elevation="2"
          class="mx-5"
          text
          outlined
          rounded
          dark
          style="background:#2F75B5;"
          min-width="100"
          @click="onCloseClick">
          閉じる
        </dd-default-button>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DdDataTable from '@/components/DdDataTable'
import DdTextBox from '@/components/DdTextBox'
import DdIconButton from '@/components/DdIconButton'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdDefaultButton from '@/components/DdDefaultButton'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'

import { mapGetters } from 'vuex'

export default {
  name: 'DdV2JutyuKensakuDialog',
  mixins: [flowMixin],
  components: {
    DdDataTable,
    DdTextBox,
    DdIconButton,
    DdCodeTextBox,
    DdDateBox,
    DdDefaultButton
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * 受注契約ID
     */
    juchuKeiyakuId: Number
  },
  data: () => ({
    juchuKeiyaku: {
      juchuKeiyakuNo: 0,
      keiyakuNm: '',
      seikyusakiCd: '',
      keiyakuStartYmd: '',
      keiyakuEndYmd: '',
      keiyakuKihonKingaku: '',
      juchuKeiyakuBiko: ''
    },
    juchuListRows: [],
    headersSeikyusakiList: header.mstTorihikisakiHeaders,
    page: 1
    // headersSeikyusakiList: [
    //   { width: '60px', text: '請求先コード', value: 'seikyusakiCd' },
    //   { width: '90px', text: '請求先名', value: 'seikyusakiNm' }
    // ]
  }),
  created () {
  },
  mounted () {
    this.initialize()
  },
  computed: {
    ...mapGetters({
      torihikisakiList: 'DDMasters/vwCMstTorihikisakiGetSeikyusaki'
    }),
    filteredSeikyusakiList () {
      // 請求先
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        return elem1.hyojiOrder - elem2.hyojiOrder
      })
    },
    computedProps () {
      return {
        ...this.$props,
        persistent: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    filteredJuchuRows () {
      return this.juchuListRows.map((elem) => {
        console.log('elem', elem)
        elem.juchuYmdDisp = filter.dateFormatter(elem.juchuYmd) ?? ''
        if (elem.sagyoYoteiYmd !== null) {
          elem.sagyoYoteiYmdDisp = filter.dateFormatter(elem.sagyoYoteiYmd) ?? ''
        }
        return elem
      })
    }
  },
  watch: {
    showDialog: function () {
      const self = this
      if (self.showDialog) {
        self.HttpClient
          .get(`/api/v1/VwCD2orcd0010/findById?id=${self.juchuKeiyakuId}`)
          .then((data) => {
            console.log('aaaa', self.juchuKeiyakuId)
            console.log('aaaa', data.payload)
            self.juchuKeiyaku = data.payload
            self.juchuKeiyaku.keiyakuStartYmdDisp = filter.dateFormatter(data.payload.keiyakuStartYmd) ?? ''
            self.juchuKeiyaku.keiyakuEndYmdDisp = filter.dateFormatter(data.payload.keiyakuEndYmd) ?? ''
          })
        self.HttpClient
          .post('/api/v1/VwCD2orcd0011/search', { JuchuKeiyakuId: self.juchuKeiyakuId })
          .then((data) => {
            self.juchuListRows = data.payload
          })
      }
    }
  },
  methods: {
    initialize: function () {
      const opt = {
        loadMasters: ['vwcmsttorihikisakigetseikyusaki'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('juchuListDialog.defineHeaderPromise')
            this.headers = [
              { width: '100px', text: '受注番号', value: 'juchuNo' },
              { width: '80px', text: '受注日', value: 'juchuYmdDisp' },
              { width: '120px', text: '受注営業所', value: 'eigyoshoNm' },
              { width: '200px', text: '取引先', value: 'torihikisakiNm' },
              { width: '80px', text: '受注明細番号', value: 'juchuMeisaiNo' },
              { width: '80px', text: '作業予定日', value: 'sagyoYoteiYmdDisp', align: 'center' },
              { width: '150px', text: '荷主', value: 'ninushiNm' },
              { width: '150px', text: '発地', value: 'hatsuchiNm' },
              { width: '150px', text: '卸先', value: 'oroshisakiNm' },
              { width: '150px', text: '着地', value: 'chakuchiNm' }
            ]
            resolve()
          })
        },
        initializeInputPromise: this.clear(),
        savedInputRestorePromise: (c) => {
          console.log('juchuListDialog.savedInputRestorePromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        researchPromise: (c) => {
          console.log('juchuListDialog.researchPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('juchuListDialog.restoreViewPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('juchuListDialog.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            resolve()
          })
        },
        getCloneTargetMethod: function () {
          return {
            juchuKeiyaku: this.juchuKeiyaku
          }
        }
      }
      this.initializeForViewer(opt)
    },
    clear: function () {
      console.log('clear')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.juchukeiyaku = {
              juchuKeiyakuNo: 0,
              keiyakuNm: '',
              seikyusakiCd: '',
              keiyakuStartYmd: '',
              keiyakuEndYmd: '',
              keiyakuKihonKingaku: '',
              juchuKeiyakuBiko: ''
            }
            self.juchuListRows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onCloseClick: function (e) {
      console.log('close clicked', this.showDialog)
      this.clear()
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
  .spx{
    height: 10px;
  }
</style>
